import { Flex, FormControl, FormLabel, Select } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaBullhorn, FaTrash, FaUserPlus } from 'react-icons/fa'
import { Button } from '../../../../../../components/Button'
import { FindUser } from '../../../../../../components/FindBox'
import { iConvite, iDemografia, iNomeId } from '../../../../../../interfaces'
import { appApi } from '../../../../../../services/appApi'
import { ModalBase } from '../../../../../../components/ModalBase'
import { ModalComunicao } from '../ModalComunicacao'
import { TableConvites } from '../Tabela'
import { ActionButton } from './styles'
import { PropInvalida } from '../../../../../../Utils/Helper'

interface iModalProps {
  isOpen: boolean
  rows: iConvite[]
  paramId: string
  Reload: () => void
  onClose: () => void
}
export const ModalConviteUsuario: React.FC<iModalProps> = ({ isOpen, rows, paramId, onClose, Reload }) => {
  const [Colaboradores, setColaboradores] = useState<iNomeId[]>([])
  const [Departamentos, setDepartamentos] = useState<iDemografia[]>([])
  const [ColaboradorId, setColaboradorId] = useState('')
  const [DepartamentoId, setDepartamentoId] = useState('')

  const [Selecionados, setSelecionados] = useState<string[]>([])

  const [ModalComunicacaoIsOpen, setModalComunicacaoIsOpen] = useState(false)

  function getColaboradores(): void {
    appApi.get('Colaborador/Select')
      .then(res => setColaboradores(res.data))
      .catch(err => console.log(err))
  }

  function getDepartamentos(): void {
    appApi.get('Departamento/Select')
      .then(res => setDepartamentos(res.data))
      .catch(err => console.log(err))
  }

  function ConvitePorColabId(): void {
    appApi.post(`PesquisaInternaConvite/${paramId}/Colaborador?colaboradorId=${ColaboradorId}`)
      .then(() => {
        Reload()
        setColaboradorId('')
      })
      .catch(err => console.log(err))
  }

  function ConvitePorDepartamentoId(): void {
    appApi.post(`PesquisaInternaConvite/${paramId}/Departamento?departamentoId=${DepartamentoId}`)
      .then(() => {
        Reload()
        setDepartamentoId('')
      })
      .catch(err => console.log(err))
  }

  function ConvidarTodosColaboradores(): void {
    appApi.post(`PesquisaInternaConvite/${paramId}/Todos`)
      .then(() => {
        Reload()
      })
      .catch(err => console.log(err))
  }

  function onCheck(id: string, all?: boolean): void {
    if (!PropInvalida(all)) {
      if (all) {
        setSelecionados(Selecionados.concat(rows.filter(r => !Selecionados.some(t => t === r.id)).map((e) => { return e.id })))
      } else {
        setSelecionados([])
      }
    } else {
      const copy = [...Selecionados]
      if (copy.find(e => e === id) === undefined) {
        copy.push(id)
        setSelecionados(copy)
      } else {
        setSelecionados([])
        const filtrado = copy.filter(e => e !== id)
        setSelecionados(filtrado)
      }
    }
  }

  function onDeleteConvites(): void {
    appApi.post('PesquisaInternaConvite/DeletarVarios', Selecionados)
      .then(() => {
        Reload()
        setSelecionados([])
      })
      .catch(err => console.log(err))
  }

  function SelecionarUsuario(id: string): void {
    setColaboradorId(id)
  }

  useEffect(() => {
    getColaboradores()
    getDepartamentos()
  }, [])

  return (
    <ModalBase
      Titulo="Convite por usuário"
      Subtitulo="Utilize os filtros para selecionar apenas os convites que desejar. Você pode filtrar por área ou nome, selecionando os convites que desejar. Poderá também clicar na barra de seleção e adicionar todos os convites que estão aparecendo na lista a partir dos filtros realizados."
      isOpen={isOpen}
      onClose={onClose}
      Width='65rem'
    >
      <ModalComunicao
        isOpen={ModalComunicacaoIsOpen}
        pesquisaId={paramId}
        onClose={() => setModalComunicacaoIsOpen(false)}
      />
      <Flex padding={'2rem'} flexDir={'column'}>
        <Flex width={'100%'}>
          <FormControl as={Flex}>
            <FormLabel width={'14rem'} fontSize={'xl'}>Convite por área</FormLabel>
            <Select value={DepartamentoId} onChange={(e) => setDepartamentoId(e.target.value)} margin={'0rem 2rem'} borderColor={'var(--Gray4)'} size='md'>
              <option value={''}>Nenhum</option>
              {
                Departamentos.map((e, i) => {
                  return (
                    <option value={e.id} key={i}>{e.nome}</option>
                  )
                })
              }
            </Select>
          </FormControl>
          <Button onClick={ConvitePorDepartamentoId} VarColor='v2'>Selecionar usuários</Button>
        </Flex>
        <Flex width={'100%'} marginTop={'1rem'}>
          <FormControl alignItems={'start'} as={Flex}>
            <FormLabel width={'14.2rem'} fontSize={'xl'}>Pesquisar usuário</FormLabel>
            <Flex width={'100%'} margin={'0 2rem'}>
              <FindUser placeholder='Digite um nome' lista={Colaboradores} onChoice={SelecionarUsuario} />
            </Flex>
          </FormControl>
          <Button VarColor='v2' onClick={ConvitePorColabId}>Selecionar usuários</Button>
        </Flex>
        <Flex margin={'1rem 0rem'} justifyContent={'space-around'}>
          <ActionButton theme={'#75AAE0'} onClick={() => setModalComunicacaoIsOpen(true)}>
            <FaBullhorn size={32} />
            <Flex flexDir={'column'}>
              <span>Adicionar comunicação</span>
              <small>Você pode adicionar textos, imagens e vídeos</small>
            </Flex>
          </ActionButton>
          <ActionButton onClick={ConvidarTodosColaboradores} theme={'var(--v2)'}>
            <FaUserPlus size={32} />
            <Flex flexDir={'column'}>
              <span>Selecionar todos os colaboradores cadastrados</span>
            </Flex>
          </ActionButton>
        </Flex>

        {
          (rows !== undefined && rows.filter(e => e.status !== 'Respondido').length > 0) && (
            <>
              <Flex marginBottom={'1rem'} fontWeight={'400'} justifyContent={'space-between'} alignItems={'center'}>
                <h3>Usuários de aplicativos selecionados</h3>
                <Button leftIcon={<FaTrash />} VarColor={'terc3'} onClick={onDeleteConvites}>Excluir convites selecionados</Button>
              </Flex>
              <TableConvites
                isEdit
                rows={rows.filter(e => e.status !== 'Respondido')}
                onCheck={onCheck}
                selecionados={Selecionados}
                onSend={() => { }}
              />
            </>
          )
        }
      </Flex>
      <Flex padding={'0 1rem 1rem 0'} justifyContent={'end'}>
        <Button VarColor='Green1' size={'lg'} onClick={onClose}>Continuar</Button>
      </Flex>
    </ModalBase>
  )
}
